import { default as config } from "common/config/config";
import WindowEvent from "ui/common/utils/WindowEvent";
import UIError, { UIErrorMesage } from "./UIError";

export type UIErrorEventSeverity = "error" | "warning";

export default class UIErrorEvent extends WindowEvent {
    static type = `${config.projectName}-error`;

    error: UIError;

    constructor(error: UIError) {
        super(UIErrorEvent.type);
        this.error = error;
    }

    static addListener(callback: (event: UIErrorEvent) => void): void {
        this.addListenerToWindow(UIErrorEvent.type, callback);
    }

    static removeListener(callback: (event: UIErrorEvent) => void): void {
        this.removeListenerFromWindow(UIErrorEvent.type, callback);
    }

    static dispatch(message: UIErrorMesage, severity: UIErrorEventSeverity = "error", details?: string): void {
        this.dispatchEvent(new UIErrorEvent(new UIError(message, severity, details)));
    }
}
